import React, { useState } from 'react';
import { ReactComponent as BackArrow } from 'assets/icons/back_arrow.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash-icon.svg';
import { useNavigate } from 'react-router-dom';
import DeleteRosterModal from '../delete-roster-modal';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import moment from 'moment';
import { apiService } from 'utils/api';
import { KITCHEN_ROUTE_KEYS } from 'utils/constants';
import { WEEKLY_ROSTER_PAGES } from 'utils/enum';

const EditReviewHeader = ({
  title,
  start_date,
  end_date
}: {
  title: string;
  start_date: string | null;
  end_date: string | null;
}) => {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const deleteRoster = async () => {
    try {
      setDeleting(true);
      const data = {
        fromDate: start_date,
        toDate: end_date
      };
      const res = await apiService.delete('kitchen/rosters', {
        params: data,
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      toast(<ToastMessage type='success' message={res.data.message} />);
      navigate(`${KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER}?start_date=${start_date}&end_date=${end_date}`);
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message[0]} />);
    } finally {
      setShowDeleteModal(false);
      setDeleting(false);
    }
  };

  const returnToPrevious = () => {
    const route = `${KITCHEN_ROUTE_KEYS.WEEKLY_ROSTER}?start_date=${start_date}&end_date=${end_date}`;
    return title === WEEKLY_ROSTER_PAGES.REVIEW ? `${route}&upload=true` : route;
  };

  return (
    <div className='bg-white'>
      <div
        className='flex items-center gap-3 mb-5 cursor-pointer'
        onClick={() => navigate(returnToPrevious())}>
        <div className='p-[6px] rounded-full bg-[#F4F1F1]'>
          <BackArrow />
        </div>
        <p className='text-sm font-medium text-[#1A1A1A]'>Return to previous</p>
      </div>
      <div className='flex items-center justify-between mb-4'>
        <div>
          <h4 className='text-xl font-semibold '>{title} roster</h4>
          <p className='text-sm text-gray-8 mt-1'>
            {moment(start_date).format('Do MMM, YYYY')} - {moment(end_date).format('Do MMM, YYYY')}
          </p>
        </div>
        {title === WEEKLY_ROSTER_PAGES.EDIT && (
          <div
            className='cursor-pointer flex items-center gap-[5px] py-[10px] px-[14px] border border-[#E60A2B] rounded-[100px]'
            role='button'
            onClick={() => setShowDeleteModal(true)}>
            <TrashIcon />
            <span className='text-[#E60A2B] font-medium text-sm'>Delete roster</span>
          </div>
        )}
      </div>

      <DeleteRosterModal
        open={showDeleteModal}
        title={`Delete Week ${moment(start_date).isoWeek()} (${moment(start_date).format(
          'Do MMM'
        )} - ${moment(end_date).format('Do MMM, YYYY')}) Roster`}
        loading={deleting}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={deleteRoster}
      />
    </div>
  );
};

export default EditReviewHeader;
